import { LinkedAnalogues } from '~/components/wiki/lithostrat/LinkedAnalogues';
import { useFormationDetailOutletContext } from '~/routes/wiki/regional/lithostrat/formation.$formationId';

export default function FormationExamplesRoute() {
  const { formation } = useFormationDetailOutletContext();
  return <LinkedAnalogues analogues={formation.outcropLinkAnalogues} />;
}
